<template>
  <div class="layout-box">
    <LayoutHeader headtitle="行业专家"></LayoutHeader>
    <div class="secondary-content">
      <GoBack></GoBack>
      <div class="experts-title">
        <div class="bread-crumb-nav">当前位置：<a href="/">首页</a> > <a @click="$router.go(-1)">行业专家</a> > 行业详情</div>
      </div>
      <div class="experts-detail">
        <div class="character-profile clear">
          <img :src='explistdata.img' height="250" width="200"/>
          <div>
            <h3>{{ explistdata.name }}</h3>
            <p><b>职称：</b>{{ explistdata.title }}</p>
            <p><b>职务：</b>{{ explistdata.position }}</p>
            <p><b>单位：</b>{{ explistdata.units }}</p>
            <p class="research"><b>研究方向：</b>{{ explistdata.research }}</p>
          </div>
        </div>
        <div>&nbsp;</div>
        <div class="main-works">
          <h3>主要著作:</h3>
          <p>{{ explistdata.book }}</p>
        </div>
        <div class="details-introduction">
          <h3>※个人情况:</h3>
          <div v-html="explistdata.personalprofile"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import LayoutHeader from "../layout/layout-header2";
import GoBack from "../layout/layout-goback";

export default {
  name: 'MatchingExpertsD',
  components:{
    LayoutHeader,
    GoBack
  },
  data () {
    return {
      explistdata:null
    }
  },
  mounted () {
    this.explistdata=JSON.parse(localStorage.getItem('expdata'))
  },
  methods:{

  }
}
</script>

<style scoped>
.layout-box {
  position: relative;
  width: 100%;
  height: calc(100% - 170px);
  padding-top: 170px;
  background: url("../../assets/erj_bj.fw.png");
  overflow: auto;
}

.layout-box::-webkit-scrollbar{
  display: none;
}


.secondary-content{
  width: 1100px;
  margin: 0 auto;
  position: relative;
  background: #0A47B6;
}

.experts-title{
  width:100%;
  height: 59px;
  background-image: linear-gradient(rgba(239,243,254,.2),rgba(197,210,250,.48));
}

.bread-crumb-nav{
  font-size: 16px;
  color: #fff;
  font-family: 微软雅黑;
  line-height: 59px;
  padding-left: 20px;
}

.bread-crumb-nav a{
  cursor: pointer;
  color: #fff;
  text-decoration: none;
}
.bread-crumb-nav a:hover{
  text-decoration: underline;
  font-weight: bold;
}

.experts-detail{
  width: 100%;
  font-size: 16px;
  color: #fff;
  line-height: 217%;
  height: calc(100% - 60px);
}

.character-profile{
  width: calc(100%-40px);
  height: 248px;
  padding: 40px 50px;
  cursor: pointer;
  box-shadow:0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  float: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.character-profile>div{
  margin-left: 20px;
  display: flex;
  flex-wrap: wrap;
}

.character-profile h3{
  font-size: 26px;
  margin-bottom: 15px;
}

.character-profile p{
  line-height: 210%;
  width: 780px;
  margin: 3px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.character-profile p.research{
  white-space:normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  word-break: break-all;
}

.main-works{
  padding: 0 10px 15px 10px;
  margin: 0 40px;
  border-bottom: 1px solid #E3E9F6;
}

.main-works p{
  margin-top: 15px;
}

.details-introduction{
  padding: 20px;
  margin: 0 40px;
  background: #0B42AF;
  text-shadow: 0 4px 1px rgba(0, 0, 0, 0.3);
}

.details-introduction h4{
  margin-top: 6px;
}

</style>

<style>
.details-introduction a{
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/secondary/secondary-experts-detail.vue